import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import * as XLSX from 'xlsx';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { ModalDirective } from 'ngx-bootstrap/modal';

import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { Restock } from '../../../common/model/restock-new.interface';
import { RestockNewService } from '../../../common/facade/restock-new.service';
import { LoggerLayoutsFacade } from '../../../common/facade/LoggerLayoutsFacade';
import { LoggerLayout } from '../../../common/model/LoggerLayout';
import { Organization } from '../../../common/model/Organization';
import { event } from 'jquery';

// for excel import
type AOA = any[][];

@Component({
  selector: 'app-restock-new',
  templateUrl: './restock-new.component.html',
  styleUrls: ['./restock-new.component.css']
})
export class RestockNewComponent implements OnInit {

  lstOrganization: Organization[] = [];
  selectedOrganizations: Organization[] = [];
  strOrganizationSelected: string;
  tenantId: number = -1;
  cmb_organization = '-1';
  fileNameUpload = '';

  titleImport = res.Import;
  lblDownloadLayout = res.DownloadLayout;
  lblStyle = res.Style;
  lblVariety = res.Variety;
  lblSize = res.Size;
  lblStatus = res.Status;
  lblRTC = res.ReinforceCentralSizes;
  lblNB = res.NewBasics;
  lblCR = res.RestockChampions;
  lblOrganization = res.Organization;
  lblSelectAnOption = res.SelectAnOption;
  lblStrategyCR = res.CR;
  lblStrategyNB = res.NB;
  lblStrategyRTC = res.RTC;

  @ViewChild('modal') public modal: ModalDirective;
  rd: string = '';
  bl: boolean = false;

  lblImportFile = res.ImportFile;
  lblChoose = res.Choose;
  lblSelectAFile = res.SelectAFile;
  lblCancel = res.Cancel;
  lblContinueSaving = res.ContinueSaving;

  lblRestock = res.Restock;
  lblRestockChampions = res.RestockChampions;
  lblReinforceCentralSizes = res.ReinforceCentralSizes;
  lblRestockSave = res.RestockSave;
  lblSave = res.Save;
  lblStrategy = res.Strategy;

  lblType = ''

  isSpanish = true;
  language = 0;

  loading = false;
  messageLoader = '';

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };

  rows: Restock[] = [];

  // alert
  alertsFileExcel = [];
  generalAlerts = [];

  // import excel
  excelData: AOA = [[], []];
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  fileName = 'SheetJS.xlsx';
  excelRows: Restock[];

  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    public strings: Strings,
    private _restockNewService: RestockNewService,
    private _router: Router,
    private _facadeLog: LoggerLayoutsFacade
  ) {
    this._storage.set('moduleUrl', this._router.url);
  }

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    this.tenantId = this.strings.getTenant();
    this.lstOrganization = this.strings.getAvailableOrganizations().filter(x => x.tenantId == this.tenantId);

    if (!this.isSpanish) {
      this.language = 1;
    }

    this.onChangeRBT();
  }

  downloadLayout() {
    const link = document.createElement('a');

    switch (this.rd) {
      case Strategy.CAMPEONES_RESURTIBLES:
        link.download = 'LayoutCR.xlsx';
        link.href = 'assets/layout/Layout_CR.xlsx';
        break;
      case Strategy.NUEVOS_BASICOS:
        link.download = 'LayoutNB.xlsx';
        link.href = 'assets/layout/Layout_NB.xlsx';
        break;
      case Strategy.REFUERZO_TALLAS_CENTRALES:
        link.download = 'LayoutRTC.xlsx';
        link.href = 'assets/layout/Layout_RTC.xlsx';
        break;
    }

    link.click();
  }

  uploadExcel(event: any) {
    this.alertsFileExcel = [];
    this.excelRows = [];
    this.rows = [];

    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(event.target);

    if (target.files.length !== 1) {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertSelectOnlyOneFile), 'danger', 'excel');
      var log = new LoggerLayout();
      var userInfo = this._storage.get('user');

      log.message = this.strings.GetText(res.AlertSelectOnlyOneFile);
      log.layoutIncidence = 'restock';
      log.userName = userInfo.account;
      log.incidenceType = 1;

      this._facadeLog.AddNewIncident(log).subscribe(result => {
        if (result.completed) {
          console.log('¡Error!, ' + this.strings.GetText(res.AlertSelectOnlyOneFile))
        }
      });

      return;
    }

    // check file is valid
    if (!this.validateFile(target.files[0].name, 'xlsx')) {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertOnlyXlsxfilesAreAccepted), 'danger', 'excel');

      var log = new LoggerLayout();
      var userInfo = this._storage.get('user');

      log.message = this.strings.GetText(res.AlertOnlyXlsxfilesAreAccepted);
      log.layoutIncidence = 'restock';
      log.userName = userInfo.account;
      log.incidenceType = 1;

      this._facadeLog.AddNewIncident(log).subscribe(result => {
        if (result.completed) {
          console.log('¡Error!, ' + this.strings.GetText(res.AlertOnlyXlsxfilesAreAccepted))
        }
      });

      return;
    }

    this.fileNameUpload = event.target.files[0].name;

    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* correct layout */
      let cl: boolean;

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.excelData = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      this.excelRows = [];
      this.excelData.forEach((element, index) => {

        if (index == 0) {
          if (element.length > 0) {
            switch (this.rd) {
              case Strategy.CAMPEONES_RESURTIBLES:
              case Strategy.NUEVOS_BASICOS:
                cl = (element[0] == 'Estilo' && element[1] == 'Variedad');
                break;
              case Strategy.REFUERZO_TALLAS_CENTRALES:
                cl = (element[0] == 'Estilo' && element[1] == 'Variedad' && element[2] == 'Talla');
                break;
            }
          }
        } else {
          if (element.length > 0) {
            switch (this.rd) {
              case Strategy.CAMPEONES_RESURTIBLES:
              case Strategy.NUEVOS_BASICOS:
                this.excelRows.push({
                  type: this.rd,
                  style: element[0],
                  variety: element[1],
                  sizes: '',
                  status: '',
                  lang: (this.isSpanish ? 'es' : 'en'),
                  user: this._storage.get('user')['account'],
                  organizationId: this.cmb_organization
                });
                break;
              case Strategy.REFUERZO_TALLAS_CENTRALES:
                this.excelRows.push({
                  type: this.rd,
                  style: element[0],
                  variety: element[1],
                  sizes: element[2],
                  status: '',
                  lang: (this.isSpanish ? 'es' : 'en'),
                  user: this._storage.get('user')['account'],
                  organizationId: this.cmb_organization
                });
                break;
            }
          }
        }

      });

      if (cl == true) {

        this.loading = true;
        this._restockNewService.PostValidateRestock(this.excelRows).subscribe(
          response => {
            this.loading = false;

            if (response.completed) {
              this.rows = response.data;
            }
            else {
              this.addAlert('<strong>' + response.message + '</strong>', 'danger', 'excel');

              var log = new LoggerLayout();
              var userInfo = this._storage.get('user');

              log.message = response.message.toString();
              log.layoutIncidence = 'restock';
              log.userName = userInfo.account;
              log.incidenceType = 1;

              this._facadeLog.AddNewIncident(log).subscribe(result => {
                if (result.completed) {
                  console.log(response.message)
                }
              });
            }

          }, error => {
            this.loading = false;
            this.addAlert('<strong>' + error + '</strong>', 'danger', 'excel');

            var log = new LoggerLayout();
            var userInfo = this._storage.get('user');

            log.message = error;
            log.layoutIncidence = 'restock';
            log.userName = userInfo.account;
            log.incidenceType = 1;

            this._facadeLog.AddNewIncident(log).subscribe(result => {
              if (result.completed) {
                console.log('Ha ocurrido un error, al validar la información del archivo, contacta al administrador del sistema.')
                this.addAlert('Ha ocurrido un error, al validar la información del archivo, contacta al administrador del sistema.', 'danger', 'excel')
              }
            });
          }
        );

        /*this.addAlert(this.strings.GetText(res.File) + ' ' + target.files[0].name + ' ' + this.strings.GetText(res.UploadedCorrectly), 'success', 'excel');*/

      }
      else {
        this.loading = false;
        this.addAlert('<strong>' + this.strings.GetText(res.IncorrectLayout) + '</strong>', 'danger', 'excel');

        var log = new LoggerLayout();
        var userInfo = this._storage.get('user');

        log.message = this.strings.GetText(res.IncorrectLayout);
        log.layoutIncidence = 'restock';
        log.userName = userInfo.account;
        log.incidenceType = 1;

        this._facadeLog.AddNewIncident(log).subscribe(result => {
          if (result.completed) {
            console.log('¡Error!, ' + this.strings.GetText(res.IncorrectLayout))
          }
        });
      }

    };

    // Actualizar el texto del elemento label con el nombre del archivo
    const label = document.querySelector('.custom-file-label');
    label.textContent = this.fileNameUpload;
  }

  private validateFile(name: String, extension: String) {
    let ext = name.substring(name.lastIndexOf('.') + 1);

    if (ext === 'xls') {
      ext = 'xlsx';
    }

    if (ext.toLowerCase() === extension) {
      return true;
    } else {
      return false;
    }
  }

  // añadir alert
  addAlert(message: String, type: String, fileType: String) {
    if (fileType === 'excel') {
      this.alertsFileExcel = [];
      this.alertsFileExcel.push({
        type: type,
        msg: message
      });
    } else {
      this.generalAlerts = [];
      this.generalAlerts.push({
        type: type,
        msg: message
      });
    }

  }

  onChangeRBT() {
    this.rd = document.querySelector('input[name="restock"]:checked')['value'];

    if (this.rd == Strategy.CAMPEONES_RESURTIBLES) {
      this.bl = false;
      this.lblType = this.strings.GetText(res.RestockChampions);
    }
    else if (this.rd == Strategy.NUEVOS_BASICOS) {
      this.bl = false;
      this.lblType = this.strings.GetText(res.NewBasics);
    }
    else if (this.rd == Strategy.REFUERZO_TALLAS_CENTRALES) {
      this.bl = true;
      this.lblType = this.strings.GetText(res.ReinforceCentralSizes);
    }

    this.rows = [];

    this.fileNameUpload = this.strings.GetText(res.SelectAFile);
    // Actualizar el texto del elemento label con el nombre del archivo
    const label = document.querySelector('.custom-file-label');
    label.textContent = this.fileNameUpload;
  }

  RestockInsert() {

    let i: number = 0;

    this.rows.forEach((r) => {
      if (r['status'] != '') {
        i += 1;
      }
    });

    if (i >= 1) {
      this.addAlert('<strong>' + this.strings.GetText(res.RestockStatus) + '</strong>', 'danger', 'excel');

      var log = new LoggerLayout();
      var userInfo = this._storage.get('user');

      log.message = this.strings.GetText(res.RestockStatus);
      log.layoutIncidence = 'restock';
      log.userName = userInfo.account;
      log.incidenceType = 1;

      this._facadeLog.AddNewIncident(log).subscribe(result => {
        if (result.completed) {
          console.log('¡Error!, ' + this.strings.GetText(res.RestockStatus))
        }
      });
    }
    else {

      this.loading = true;
      this._restockNewService.PostRestock(this.rows).subscribe(
        response => {
          this.loading = false;

          if (response.completed) {
            this.rows = [];
            this.addAlert(this.strings.GetText(this.lblRestockSave), 'success', 'excel');
          }
          else {
            this.addAlert('<strong>' + response.message + '</strong>', 'danger', 'excel');

            var log = new LoggerLayout();
            var userInfo = this._storage.get('user');

            log.message = response.message.toString();
            log.layoutIncidence = 'restock';
            log.userName = userInfo.account;
            log.incidenceType = 1;

            this._facadeLog.AddNewIncident(log).subscribe(result => {
              if (result.completed) {
                console.log(response.message)
              }
            });
          }

        }, error => {
          this.loading = false;
          this.addAlert('<strong>' + error + '</strong>', 'danger', 'excel');
          var log = new LoggerLayout();
          var userInfo = this._storage.get('user');

          log.message = error;
          log.layoutIncidence = 'restock';
          log.userName = userInfo.account;
          log.incidenceType = 1;

          this._facadeLog.AddNewIncident(log).subscribe(result => {
            if (result.completed) {
              console.log('Ha ocurrido un error, contacta al administrador del sistema.')
            }
          });
        }
      );

    }

    this.fileNameUpload = this.strings.GetText(res.SelectAFile);
    // Actualizar el texto del elemento label con el nombre del archivo
    const label = document.querySelector('.custom-file-label');
    label.textContent = this.fileNameUpload;


  }

  onChangeOrganization() {
    this.rows = [];

    this.fileNameUpload = this.strings.GetText(res.SelectAFile);
    // Actualizar el texto del elemento label con el nombre del archivo
    const label = document.querySelector('.custom-file-label');
    label.textContent = this.fileNameUpload;
  }

}

export const Strategy = {
  CAMPEONES_RESURTIBLES: 'cr',
  NUEVOS_BASICOS: 'nb',
  REFUERZO_TALLAS_CENTRALES: 'rtc'
}
